<template>
  <v-form
    v-if="id"
    v-model="valid"
    class="py-8 bg-light-blue-main">
    <v-row class="pa-4">
      <v-col cols="12">
        <v-container class="bordered bg-white">
          <DescriptionPart :location-id="id" />
        </v-container>
      </v-col>
      <!-- <v-col
        class="text-center"
        cols="3">
        <ElementButtons
          hide-submit
          :node-id="nodeId" />
      </v-col> -->
    </v-row>

    <v-row class="pa-4">
      <v-col cols="12">
        <ShiftModelTable
          class="bordered bg-white"
          :location-id="id" />
      </v-col>
      <v-col cols="12">
        <ActivityTable
          class="bordered bg-white"
          :location-id="id" />
      </v-col>
      <v-col cols="12">
        <PricesPart :location-id="id" />
      </v-col>
      <v-col cols="12">
        <SurchargesPart :location-id="id" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";

import DescriptionPart from "./DescriptionPart.vue";
import PricesPart from "./PricesPart.vue";
import SurchargesPart from "./SurchargesPart.vue";
import ShiftModelTable from "./ShiftModelTable.vue";
import ActivityTable from "./ActivityTable.vue";
import { useSpaceStore } from "@/stores/spaceStore";

const spaceStore = useSpaceStore();

const valid = ref(false);
const loading = ref(false);

// Form fields, only for validation
const location = ref(null);

const props = defineProps({
  closeDialog: {
    type: Function,
    required: true
  },
  id: {
    type: String,
    default: null
  }
});

const route = useRoute();

const id = computed(() => route.params.nodeId);

onMounted(() => {
  if (!id.value) {
    id.value = spaceStore.createElement("location");
  }
  location.value = spaceStore.getElement(id.value);
});
</script>

<style>
.v-form {
  max-height: 100%;
  overflow: auto;
  background-color: white;
}
</style>
